import colors from '@theme/colors';
import { scale, verticalScale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  baruStyle: { left: 15, marginTop: scale(5) },
  enabledDisabledOpacity: bpCategoryProducts => ({ opacity: bpCategoryProducts.availability ? 1.0 : 0.5 }),
  enabledDisabledStyles: bpCategoryProducts => ({
    backgroundColor: bpCategoryProducts.availability ? colors.neutral.cotton : colors.neutral.mist,
    elevation: bpCategoryProducts.availability ? 6 : 0,
    shadowOffset: bpCategoryProducts.availability
      ? {
          width: 0,
          height: 3,
        }
      : {},
    shadowOpacity: bpCategoryProducts.availability ? 0.27 : 0,
    shadowRadius: bpCategoryProducts.availability ? 4.65 : 0,
  }),
  productNameText: {
    lineHeight: scale(16), // Ensure proper line height
    marginTop: verticalScale(8),
    paddingHorizontal: scale(4), // Add horizontal padding to prevent text overflow
    textAlign: 'center',
  },
  productTile: {
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: scale(80), // Ensure minimum height
  },
  productTileButton: {
    alignItems: 'center',
    height: scale(60),
    marginHorizontal: 0,
    marginTop: verticalScale(12),
    paddingHorizontal: scale(15),
    paddingVertical: verticalScale(15),
    width: scale(60),
  },
});
export default styles;
